<template>
	<TransitionRoot as="template" :show="isOpen">
		<Dialog as="div" class="relative z-50" @close="close">
			<TransitionChild
				as="template"
				enter="ease-out duration-300"
				enter-from="opacity-0"
				enter-to="opacity-100"
				leave="ease-in duration-200"
				leave-from="opacity-100"
				leave-to="opacity-0">
				<div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
			</TransitionChild>

			<div class="fixed inset-0 z-10 w-screen overflow-y-auto">
				<div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
					<TransitionChild
						as="template"
						enter="ease-out duration-300"
						enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						enter-to="opacity-100 translate-y-0 sm:scale-100"
						leave="ease-in duration-200"
						leave-from="opacity-100 translate-y-0 sm:scale-100"
						leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
						<DialogPanel
							class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-7xl">
							<!-- Header -->
							<div class="bg-gray-50 px-6 py-4 border-b border-gray-200">
								<div class="flex items-center justify-between">
									<DialogTitle class="text-lg font-semibold text-gray-900">
										{{ title }}
									</DialogTitle>
									<button
										type="button"
										class="text-gray-400 hover:text-gray-500"
										@click="close">
										<span class="sr-only">Close</span>
										<svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
										</svg>
									</button>
								</div>
							</div>
							
							<!-- Content -->
							<div class="bg-white px-6 py-4 max-h-[85vh] overflow-y-auto">
								<slot></slot>
							</div>
							
							<!-- Footer -->
							<div v-if="$slots.footer" class="bg-gray-50 px-6 py-4 border-t border-gray-200">
								<slot name="footer"></slot>
							</div>
						</DialogPanel>
					</TransitionChild>
				</div>
			</div>
		</Dialog>
	</TransitionRoot>
</template>

<script lang="ts" setup>
	import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

	interface Props {
		isOpen: boolean
		title: string
	}

	defineProps<Props>()

	const emit = defineEmits<{
		close: []
	}>()

	const close = () => {
		emit('close')
	}
</script>
